<template>
	<div class="footer">
		<img src="@/assets/images/footer_icon.png" />
		<a v-if="domain.includes('wochengheyan')" href="https://beian.miit.gov.cn">网站备案：闽ICP备2024049580号-1</a>
		<a v-if="domain.includes('luyouxuan')" href="https://beian.miit.gov.cn">网站备案：闽ICP备2024049580号-2</a>
		<!-- <span style="padding-left: 10px;">版权所有：厦门沃橙电子商务有限公司</span> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				domain: window.location.host
			}
		},
		onLoad(option) {

		},
	}
</script>

<style scoped lang="less">
	.footer{
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 20px 0;
		background: #EFEFEF;
		img{
			height: 20px;
			width: auto;
			margin-right: 8px;
		}
		a {
			color: #677897;
			font-size: 12px;
		}
		span {
			color: #677897;
			font-size: 12px;
		}
	}
</style>